module.exports = __webpack_public_path__ + "media/header-ua.8097cb3f.mp4";